/** The transient status line under the ribbon. */

import { hudState } from "./hud.state.ts";

/** How long a non-sticky message stays up. */
const HUD_TIMEOUT_MS = 1800;

let timer: ReturnType<typeof setTimeout> | null = null;

export function setHud(message: string | null, sticky = false): void {
  if (timer !== null) {
    clearTimeout(timer);
    timer = null;
  }

  hudState.set({ message, sticky });
  if (message === null || sticky) {
    return;
  }

  timer = setTimeout(() => {
    hudState.set({ message: null, sticky: false });
    timer = null;
  }, HUD_TIMEOUT_MS);
}

export function clearHud(): void {
  setHud(null);
}
